import RequestPageTwo from "./RequestPageTwo";

const LandLotRequest = () => {
    return (
        <RequestPageTwo title="LandLot Request form"
            fetchUrl="/get-land-lot-requests"
            editEndpoint="update-land-lot-requests"
            deleteEndpoint="land-lot-requests"
            statusEndpoint="update-land-lot-requests" />
    );
}

export default LandLotRequest;
